module.exports = __webpack_public_path__ + "img/person3.29f14055.png";